export default [
  {
    name: "online-reservations",
    meta: {
      title: "Online Reservations",
      sort: 8,
      authenticatable: true,
      description: "Online Reservations",
      icon: "mdi-clipboard-text-outline",
      permission: false,
      roles: ["admin", "dealer"],
    },
  },
];
